import { SearchApi } from '@/api'
import { configuration } from '@/lib/api'

export const searchApi = new SearchApi(configuration)
